import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"image-card"},[_c(VImg,{staticClass:"rounded-lg",attrs:{"src":"https://slide1-images.s3.amazonaws.com/public/relatorio-administrativo/relatório-de-marketing-digital-blog.png"}})],1),_c('div',{staticClass:"py-2"},[_c(VCardTitle,{staticClass:"py-0 px-2 title-card"},[_vm._v(_vm._s(_vm.relatorio.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }